import React from 'react';
import { FilePlus2, ArrowRight } from 'lucide-react';

// Client dashboard: the way into a new loan application, which opens in a
// panel over the dashboard.
const ApplyForLoanCard = ({ onApply }) => (
  <div className="relative overflow-hidden rounded-lg shadow p-4 border border-blue-500/40 bg-gradient-to-br from-blue-600 via-indigo-600 to-violet-600 text-white flex flex-col justify-between gap-3">
    <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-white/10" aria-hidden="true" />
    <div className="absolute -right-2 bottom-2 h-12 w-12 rounded-full bg-white/10" aria-hidden="true" />
    <div className="relative flex items-start gap-3">
      <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white/15">
        <FilePlus2 size={22} />
      </span>
      <div>
        <h2 className="text-lg font-semibold leading-tight">Need a loan?</h2>
        <p className="mt-0.5 text-xs text-blue-100">
          Check what you qualify for with your payslip and bank statement, then apply in a few steps.
        </p>
      </div>
    </div>
    <button
      type="button"
      onClick={onApply}
      className="relative inline-flex items-center justify-center gap-2 self-start rounded-lg bg-white px-4 py-2 text-sm font-bold text-blue-700 shadow-md hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-white/70"
    >
      Apply for a loan <ArrowRight size={16} />
    </button>
  </div>
);

export default ApplyForLoanCard;
